'use strict'

const WPhoto = require('./WPhoto')
const _ = require('lodash')

const ClipArt = _.defaults({displayName: 'ClipArt'}, WPhoto)

module.exports = ClipArt